import React from 'react';
import type { ExtractLayoutType, SharedBlockType } from '../types';
import type { PagesQuery, ServicesQuery, ServicesQueryVariables } from '../../graphql/generated/schema';
import { ServicesScrollerClient } from './index.client';
import { cmsClient } from '../../graphql';
import { SERVICES } from '../../graphql/query/service';

export const ServicesScroller: React.FC<SharedBlockType & ExtractLayoutType<PagesQuery, 'ServicesScroller'>> = async (props) => {
  const { services, serviceScrollerMethod } = props;

  const { Services } = await cmsClient.request<ServicesQuery, ServicesQueryVariables>(SERVICES, {
    limit: 10,
    page: 1,
    sort: 'title',
    ...(serviceScrollerMethod === 'manual' ? {
      where: {
        id: {
          in: services?.map(({ id }) => id) || [],
        },
      },
    } : {
      sort: 'title',
    }),
  }).then((data) => {
    if (serviceScrollerMethod === 'manual') {
      return {
        Services: {
          docs: data.Services?.docs?.sort((a, b) => {
            const aIndex = services?.findIndex(({ id }) => id === a?.id);
            const bIndex = services?.findIndex(({ id }) => id === b?.id);
            return (aIndex || 0) - (bIndex || 0);
          }) || [],
        }
      };
    }
    return data;
  });

  return (
    <ServicesScrollerClient
      {...props}
      serviceDocs={Services}
    />
  );
};
